import { useAnimatedNumber } from "./hooks/use-animated-number"

// interface AnimatedNumberProps {
//   value: string | number
//   duration?: number
//   delay?: number
//   enabled?: boolean
//   className?: string
//   style?: React.CSSProperties
// }

export default function AnimatedNumber({
    value,
    duration = 2000,
    delay = 0,
    enabled = true,
    className = "",
    style,
}) {
    // 檢查是否為純數字
    const newValue = value ?? 0
    const str = newValue.toString().trim()

    const isPureNumber = /^-?\d+(\.\d+)?$/.test(str)

    const numericValue = isPureNumber ? Number(str) : null
    const isNumeric = isPureNumber

    const { displayValue, isAnimating } = useAnimatedNumber({
        value: isNumeric ? numericValue : 0,
        duration,
        delay,
        enabled: enabled && isNumeric,
    })

    // 如果不是數字，直接顯示原值
    if (!isNumeric) {
        return (
            <span className={className} style={style}>
                {newValue}
            </span>
        )
    }

    // 格式化數字顯示
    const formatNumber = (num) => {
        // 如果原值包含百分號，保持百分號格式
        if (newValue.toString().includes("%")) {
            return `${num.toFixed(1)}%`
        }
        // 如果原值包含加號，保持加號格式
        if (newValue.toString().includes("+")) {
            return `+${num.toLocaleString()}`
        }
        // 一般數字格式
        return num.toLocaleString()
    }

    return (
        <span className={`${className} ${isAnimating ? "animate-pulse" : ""}`} style={style}>
            {formatNumber(displayValue)}
        </span>
    )
}
